// pdf generation
import * as pdfjsLib from 'pdfjs-dist'
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker

export const validateRequiredFields = async (formValues, selectedTemplateForm) => {
  const errors = {};

  Object.entries(selectedTemplateForm).forEach(([section, fields]) => {
    if (!Array.isArray(fields)) return;

    fields.forEach((field) => {
      if (field.required) {
        const value = formValues[section]?.[field.name];
        if (
          value === undefined ||
          value === null ||
          (typeof value === "string" && !value.trim())
        ) {
          errors[field.name] = `${field.label} is required`;
        }
      }
    });
  });

  console.log("validation errors", errors);
  return errors;
};

export const buildQueryParams = (selectedTemplate, formValues) => {
  const queryParams = {
    template: selectedTemplate,
    contact: formValues.contact,
    customer: formValues.customer,
  };

  return queryParams;
};

export const copyArrayBuffer = (arrayBuffer) => {
  const copiedBuffer = new ArrayBuffer(arrayBuffer.byteLength)
  const view = new Uint8Array(copiedBuffer)
  view.set(new Uint8Array(arrayBuffer))
  return copiedBuffer
}

export const renderPdf = async (pdfBinaryData) => {
  try {
    const pdfDataCopy = copyArrayBuffer(pdfBinaryData)
    console.log('data copy', pdfDataCopy)

    const pdf = await pdfjsLib.getDocument({ data: pdfDataCopy }).promise
    console.log('pdf length', pdf.numPages)

    const pdfImages = []
    for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
      const page = await pdf.getPage(pageNumber)

      const scale = 1.5
      const viewport = page.getViewport({ scale })

      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')

      canvas.width = viewport.width
      canvas.height = viewport.height

      await page.render({ canvasContext: context, viewport }).promise

      pdfImages.push(canvas.toDataURL())
    }

    return pdfImages
  } catch (error) {
    console.error('Error rendering PDF:', error.message)
    throw error
  }
}

export const constructAndReturnValidationErrorMessage = (
  data,
  errorMessageString
) => {
  const messages = data?.message || [];
  const errorDetails = Array.isArray(messages)
    ? messages.map((m) => ` ${m}`).join("\n")
    : String(messages);

  return `${errorMessageString}\n${errorDetails}`;
};

export const validateForm = (name, phone, email, userName) => {
  if (!name?.trim()) {
    return { isValid: false, errorMessage: 'Organization Name is required.' }
  }

  if (!userName?.trim()) {
    return { isValid: false, errorMessage: 'User Name is required.' }
  }

  if (!email?.trim()) {
    return { isValid: false, errorMessage: 'Email is required.' }
  }

  if (!phone?.trim()) {
    return { isValid: false, errorMessage: 'Phone number is required.' }
  }

  if (!validateUserEmail(email)) {
    return { isValid: false, errorMessage: 'The email format is invalid.' }
  }

  if (!validatePhoneNumber(phone)) {
    return {
      isValid: false,
      errorMessage:
        'Please enter a valid number including the country code.',
    }
  }

  return { isValid: true }
}


export const validateUserEmail = (email) => {
  if (!email) return false

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
  return emailRegex.test(email)
}

export const validatePhoneNumber = (phone) => {
  const phoneNumber = parsePhoneNumberFromString(phone)
  return phoneNumber?.isValid() ?? false
}

export const formatPhoneNumber = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 10)
  const part1 = digits.slice(0, 3)
  const part2 = digits.slice(3, 6)
  const part3 = digits.slice(6, 10)
  let formatted = part1
  if (part2) formatted += '-' + part2
  if (part3) formatted += '-' + part3
  return formatted
}
